import { SET_CONTACT_METHODS, REMOVE_CONTACT_METHOD, ADD_CONTACT_METHOD } from "../constants";
import { ContactMethod } from "../../types";

const initial_state = {
  loading: false,
  list: [] as ContactMethod[],
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function ContactMethods(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case SET_CONTACT_METHODS:
      return {
        ...state,
        loading: false,
        list: payload,
      };

    case ADD_CONTACT_METHOD:
      return {
        ...state,
        loading: false,
        list: state.list.concat([payload]),
      };

    case REMOVE_CONTACT_METHOD:
      return {
        ...state,
        loading: false,
        list: state.list.filter((contactMethod) => contactMethod.id !== payload.id),
      };

    default:
      return state;
  }
}
